var $e7c0558801482852$exports = {};
$e7c0558801482852$exports = {
    "loading": `\u{12E}keliama...`,
    "placeholder": `Pasirinkite\u{2026}`
};


export {$e7c0558801482852$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
